import CONFIG from "@/config";
import moment from "moment";
import * as utils from "@/utils/index";
import * as tagUtils from "@/utils/tagUtils";
import * as bkpData from "@/utils/bkpData";

// ref: https://stackoverflow.com/questions/10473745/compare-strings-javascript-return-of-likely
export function editDistance(s1, s2) {
  s1 = s1.toLowerCase();
  s2 = s2.toLowerCase();

  var costs = new Array();
  for (var i = 0; i <= s1.length; i++) {
    var lastValue = i;
    for (var j = 0; j <= s2.length; j++) {
      if (i == 0)
        costs[j] = j;
      else {
        if (j > 0) {
          var newValue = costs[j - 1];
          if (s1.charAt(i - 1) != s2.charAt(j - 1))
            newValue = Math.min(Math.min(newValue, lastValue),
              costs[j]) + 1;
          costs[j - 1] = lastValue;
          lastValue = newValue;
        }
      }
    }
    if (i > 0)
      costs[s2.length] = lastValue;
  }
  return costs[s2.length];
}

export function similarity(s1, s2) {
  var longer = s1;
  var shorter = s2;
  if (s1.length < s2.length) {
    longer = s2;
    shorter = s1;
  }
  var longerLength = longer.length;
  if (longerLength == 0) {
    return 1.0;
  }
  return (longerLength - editDistance(longer, shorter)) / parseFloat(longerLength);
}

const WORD_SIMILARITY_THRESHOLD = 0.65;

// returns if inputText has a fuzzy match(65% similar) with any of the targetWords
export function performFuzzyTextMatch(inputText, targetWords, opts) {
  let defaultOpts = {
    caseInsen: true,
    exactMatch: false,
    similarityThreshold: WORD_SIMILARITY_THRESHOLD
  };
  let _opts = { ...defaultOpts, ...(opts || {}) };
  if (!Array.isArray(targetWords)) targetWords = [targetWords];
  let caseInsen = _opts.caseInsen;
  let exactMatch = _opts.exactMatch;
  let doesMatchTgtWd = targetWords.map(w => {
    let doesMatch = false;
    if (caseInsen) w = w.toLowerCase();
    if (exactMatch) doesMatch = w === inputText;
    else doesMatch = similarity(inputText, w) > _opts.similarityThreshold;
    return doesMatch;
  });
  let hasAMatch = doesMatchTgtWd.reduce((a, b) => a || b, false);
  return hasAMatch;
}

export function extractKeywords(item, possibleReleventColumnKws) {
  let releventCols = item.column_values.filter(c => performFuzzyTextMatch(c.title, possibleReleventColumnKws) );
  let tagsFmColVals = new Set();
  releventCols.forEach(c => {
    c.text
    .split(/[\s.\*+-/_]/) // split by whitespace, comma, hyphens, underscores etc.
    .forEach(w => {
      // remove whitespaces
      let lw = w.replace(/[\W_]+/g, "").toLowerCase();
      if (lw.length < 3) return;
      tagsFmColVals.add(lw);
      if (lw.match(/^.*s$/)) {
        tagsFmColVals.add(lw.replace(/.$/, ''));
      }
    });
  });
  return Array.from(tagsFmColVals);
}

export async function getConverts_to(item) {
  let possColKwsFor_converts_to = [
    "converts_to", "salvage", "material", "recycle"
  ];
  let retVal = extractKeywords(item, possColKwsFor_converts_to);
  if (CONFIG.USE_BKP_DATA && retVal.length < 1) {
    let randInt = utils.getHash(item.id, bkpData.converts_to.length);
    let randSubset = utils.getRandomItems(bkpData.converts_to, randInt);
    retVal = randSubset;
  }
  return retVal;
}

export async function getConverts_from(item) {
  let possColKwsFor_converts_from = [
    "converts_from", "raw", "material", "rawmaterial"
  ];
  let retVal = extractKeywords(item, possColKwsFor_converts_from);
  if (CONFIG.USE_BKP_DATA && retVal.length < 1) {
    let randInt = utils.getHash(item.id, bkpData.converts_from.length);
    let randSubset = utils.getRandomItems(bkpData.converts_from, randInt);
    retVal = randSubset;
  }
  return retVal;
}

export async function getIngredients(item) {
  let possColKwsFor_ingredients = [
    "ingredients", "raw", "material", "rawmaterial", "components", "contain"
  ];
  let retVal = extractKeywords(item, possColKwsFor_ingredients);
  if (CONFIG.USE_BKP_DATA && retVal.length < 1) {
    let randInt = utils.getHash(item.id, bkpData.ingredients.length);
    let randSubset = utils.getRandomItems(bkpData.ingredients, randInt);
    retVal = randSubset;
  }
  return retVal;
}

export async function getTags(item) {
  let possColKwsFor_tags = [
    "tag", "label", "keywords", "features", "type"
  ];
  let retVal = extractKeywords(item, possColKwsFor_tags);
  if (CONFIG.USE_BKP_DATA && retVal.length < 1) {
    let randInt = utils.getHash(item.id, bkpData.tags.length);
    let randSubset = utils.getRandomItems(bkpData.tags, randInt);
    retVal = randSubset;
  }
  return retVal;
}

export async function getPossConversionData(item) {
  let poss_converts_to = await getConverts_to(item);
  let poss_converts_from = await getConverts_from(item);
  let poss_ingredients = await getIngredients(item);
  let poss_tags = await getTags(item);
  return {
    poss_converts_to,
    poss_converts_from,
    poss_ingredients,
    poss_tags,
  };
}








let poolTxnInfo = {
  matLbl: "",
  timestamp: "",
  changeQty: 0,
  changeUts: "",
  src: {},
  // rptFreq: "single",
  // rptStartTimestamp: "",
  // rptCount: 1
};

let defaultMatPoolData = {
  matLbl: "",
  txns: [],
};



function extractRecycleQty(itemNode, matLbl) {
  let r = utils.randomNumber(0, 5);
  let ret = {
    quantity: [6, 24, 55, 72, 300][r],
    units: ["pcs", "kg", "lbs", "units", "lbs"][r]
  };
  return ret;
}

function extractRetireDate(itemNode, bkpVal = "2022-07-01") {
  let dt =  (itemNode
              .column_values
              .find(cv => 
                performFuzzyTextMatch(
                  cv.title,
                  [
                    "expriring date",
                    "retire date",
                    "dispose date",
                    "recycle date",
                    "last date",
                    "recycle date",
                    "last use date"
                  ],
                  { similarityThreshold: 0.8 }
                )) || {}).text;
  return dt || bkpVal;
}

function getMatIcon(matInfo) {
  let spr = tagUtils.getAppropriateSprite(matInfo);
  return spr;
}

export function getRecoverableMatResourcesInfo(itemNodes) {
  let matToPoolInfoDict = {};


  for(let itemNode of itemNodes) {
    for(let matLbl of itemNode.converts_to) {
      let poolInfo = matToPoolInfoDict[matLbl];
      if (!matToPoolInfoDict[matLbl]) {
        poolInfo = JSON.parse(JSON.stringify(defaultMatPoolData));
        poolInfo.matLbl = matLbl;
        matToPoolInfoDict[matLbl] = poolInfo;
      }

      let itemRetDateTxt = extractRetireDate(itemNode, "2022-07-01");
      let recycleVolObj = extractRecycleQty(itemNode, matLbl);

      let newTx = JSON.parse(JSON.stringify(poolTxnInfo));
      newTx.matLbl = matLbl;
      newTx.timestamp = itemRetDateTxt;
      newTx.changeQty = recycleVolObj.quantity;
      newTx.changeUts = recycleVolObj.units;
      newTx.src = itemNode;
      poolInfo.iconSrc = getMatIcon(itemNode);

      poolInfo.txns.push(newTx);

      let q = extractRecycleQty(itemNode, matLbl);
      poolInfo.totalQty = q.quantity;
      poolInfo.totalUts = q.units;
    }
  }

  return matToPoolInfoDict;
}


export function extractTxnArray(materialPoolInfo) {
  let retVal = {
    startDate: "",
    endData: "",
    txns: [],
  };

  let txns = materialPoolInfo
            .map(matIt => matIt.txns || []).flat()
            .sort((a, b) => moment(a.timestamp).unix() - moment(b.timestamp).unix())
            // .filter((value, index, self) => {
            //   return index === self.findIndex((t) => (
            //     moment(t.timestamp).isSame(moment(value.timestamp), "seconds")
            //   ))
            // });
  retVal.txns = txns;
  retVal.startDate = retVal.txns[0].timestamp;
  retVal.endData = retVal.txns[retVal.txns.length - 1].timestamp;

  return retVal;
}